import React, { useCallback, useEffect, useState } from "react";
import aprobacionPlanoApi from "@/api/AprobacionPlano";
import ViewerPdf from "@/components/pdf/Viewer";
import PropTypes from "prop-types";

export const Step3 = ({ show, user, infoCert }) => {
  const [dataCertificado, setDataCertificado] = useState("");
  const [loading, setLoading] = useState(false);

  const cedularuc = user?.cedularuc ?? "";
  const codigo = infoCert?.codigo;
  const tipo = infoCert?.tipo;

  const generarCertificado = useCallback(async () => {
    // guards para evitar requests incompletas
    if (!cedularuc || !codigo || !tipo) return;

    setLoading(true);
    try {
      const resp = await aprobacionPlanoApi.getCertificado(cedularuc, codigo, tipo);

      const items = resp.data?.data ?? [];
      if (!Array.isArray(items) || items.length === 0) {
        show({
          type: "error",
          title: resp.data?.error ?? "Error",
          message: "No se ha podido consultar la solicitud",
        });
        setDataCertificado("");
        return;
      }

      const pdf = items.find((item) => item?.Nombre === "PDF")?.Valor;
      setDataCertificado(pdf ?? "");
    } catch  {
      show({
        type: "error",
        title: "Error",
        message: "Ocurrió un error al generar el certificado, intente nuevamente por favor",
      });
    } finally {
      setLoading(false);
    }
  }, [cedularuc, codigo, tipo, show]);

  useEffect(() => {
    generarCertificado();
  }, [generarCertificado]);

  return <ViewerPdf isLoading={loading} base64={dataCertificado} />;
};

export default Step3;

Step3.propTypes = {
  show: PropTypes.func.isRequired,
  user: PropTypes.object,
  infoCert: PropTypes.object,
};
